const isStaff = (user: any) => {
  if (user.first_name !== "") {
    if (
      user.role.name === "Employee" ||
      user.role.name === "Supervisor" ||
      user.role.name === "Admin"
    ) {
      return true;
    }
    return false;
  }
  return false;
};

function formatISODateString(date: Date | string | null | undefined) {
  // Return formatted string date as mm-dd-yyyy
  if (!date) return null;
  //convert to Date object if string
  if (!(date instanceof Date)) date = new Date(date);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}

function formatGraphData(data:any){
  const keys = Object.keys(data)
  const res = new Array(data[keys[0]].length).fill(null)

  res.forEach((e,i)=>{
    const d: { [key: string]: any } = {};
    for(let key of keys){
      d[key] = data[key][i]
    }
    res[i] = d
  })

  return res

}

function formatYearlyGraphData(data:any,yearsKey="years",dataKey=['data']){
  const res = new Array(data[yearsKey].length).fill(null)
  res.forEach((e,i)=>{
    const d: { [key: string]: any } = {};
    d['year'] = data[yearsKey][i]
    for(let key of dataKey){
      d[key] = data[key][i]
    }
    res[i] = d
  })

  return res

}

export { isStaff, formatISODateString, formatGraphData, formatYearlyGraphData };


